var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPaid48Line = function SvgIconPaid48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.999 8.3a15.7 15.7 0 1 0 15.7 15.7 15.71 15.71 0 0 0-15.7-15.7Zm0 28a12.3 12.3 0 1 1 12.3-12.3 12.32 12.32 0 0 1-12.3 12.3Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.789 22.46h-.05c-1.14-.29-2-.52-2-1.2 0-.68.59-.76 1.17-.76s1.26.27 1.26 1h3.41a3.67 3.67 0 0 0-3.11-3.79h-.12V16.5h-2.81v1.2h-.12a3.57 3.57 0 0 0-3.19 3.62c0 2.78 2.24 3.34 4 3.78h.06c1.13.28 2 .5 2 1.24s-.7 1-1.36 1a1.26 1.26 0 0 1-1.41-1.21h-3.52a4 4 0 0 0 3.47 4.06h.12v1.31h2.76v-1.28h.12a3.82 3.82 0 0 0 3.39-3.88c.07-2.81-2.32-3.43-4.07-3.88Z",
    fill: "current"
  })));
};
export default SvgIconPaid48Line;